module.exports = __webpack_public_path__ + "img/2.04.thmb.6eb63c3f.jpg";